import { AlertTriangle } from 'lucide-react';

import { Button } from '@/components/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';
import { cn } from '@/lib/utils';

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  className?: string;
}

/** 조회 실패 상태 — Admin Kit Empty 구성(아이콘·제목·설명·다시 시도). TanStack Query `isError` 분기 공용. */
export function ErrorState({
  title = '정보를 불러오지 못했습니다',
  message,
  onRetry,
  className,
}: ErrorStateProps) {
  return (
    <Empty className={cn('p-6 md:p-10', className)} role="alert">
      <EmptyHeader>
        <EmptyMedia variant="icon" className="bg-destructive/10 text-destructive">
          <AlertTriangle aria-hidden="true" />
        </EmptyMedia>
        <EmptyTitle className="text-base">{title}</EmptyTitle>
        {message && <EmptyDescription>{message}</EmptyDescription>}
      </EmptyHeader>
      {onRetry && (
        <EmptyContent>
          <Button variant="outline" size="sm" onClick={onRetry}>
            다시 시도
          </Button>
        </EmptyContent>
      )}
    </Empty>
  );
}
